module.exports = __webpack_public_path__ + "img/10-4.fce80dc8.png";